var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTier1CapitalRatio = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80144 10.2489H15.2782L16.1376 9.56189C16.6221 9.17641 16.8036 8.54794 16.5981 7.96296C16.3941 7.37798 15.8617 7 15.2422 7H8.83594C8.21797 7 7.68549 7.37798 7.48 7.96296C7.27451 8.54794 7.456 9.17641 7.93898 9.56039L8.80144 10.2489Z",
    fill: "#00D2A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5951 11.75H8.50935C6.74092 13.8004 5.60547 16.8798 5.60547 19.1162C5.60547 21.5461 6.90291 24 9.7993 24H14.4491C17.347 24 18.6429 21.5476 18.6429 19.1162C18.6444 16.6728 17.3425 13.7119 15.5951 11.75Z",
    fill: "#00D2A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80144 10.2489H15.2782L16.1376 9.56189C16.6221 9.17641 16.8036 8.54794 16.5981 7.96296C16.3941 7.37798 15.8617 7 15.2422 7H8.83594C8.21797 7 7.68549 7.37798 7.48 7.96296C7.27451 8.54794 7.456 9.17641 7.93898 9.56039L8.80144 10.2489Z",
    fill: "#6C7DE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19252 3.25037H9.66926L10.5287 2.56339C11.0132 2.17791 11.1947 1.54944 10.9892 0.96446C10.7852 0.377984 10.2527 0 9.63326 0H3.22702C2.60905 0 2.07657 0.377985 1.87258 0.962961C1.66708 1.54794 1.84858 2.17641 2.33156 2.56039L3.19252 3.25037Z",
    fill: "#00D2A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1553 3.25037H20.632L21.4915 2.56339C21.9759 2.17791 22.1574 1.54944 21.9519 0.96446C21.7479 0.377984 21.2155 0 20.5975 0H14.1913C13.5733 0 13.0408 0.377985 12.8353 0.962961C12.6298 1.54794 12.8113 2.17641 13.2943 2.56039L14.1553 3.25037Z",
    fill: "#00D2A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9504 4.75H13.8647C13.6607 4.98699 13.4672 5.23898 13.2812 5.49997H15.2417C16.5061 5.49997 17.5951 6.27244 18.0136 7.46789C18.432 8.66334 18.0631 9.94579 17.0716 10.7348L16.8481 10.9147C18.318 12.6232 19.425 14.8686 19.896 16.994C22.7279 16.943 23.9998 14.5206 23.9998 12.1147C23.9998 9.6713 22.6994 6.71042 20.9504 4.75Z",
    fill: "#00D2A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34682 16.9976C4.8013 14.8617 5.86626 12.5908 7.2492 10.9273L7.00321 10.7293C6.01475 9.94188 5.64577 8.65943 6.06575 7.46398C6.48423 6.26853 7.57169 5.49606 8.83614 5.49606H10.6001C10.4036 5.23357 10.2011 4.98158 9.99109 4.74609H2.90388C1.13545 6.79801 0 9.87888 0 12.1138C0 14.5437 1.29745 16.9976 4.19383 16.9976H4.34682Z",
    fill: "#00D2A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5951 11.75H8.50935C6.74092 13.8004 5.60547 16.8798 5.60547 19.1162C5.60547 21.5461 6.90291 24 9.7993 24H14.4491C17.347 24 18.6429 21.5476 18.6429 19.1162C18.6444 16.6728 17.3425 13.7119 15.5951 11.75Z",
    fill: "#6C7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTier1CapitalRatio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tier_1_capital_ratio.b85f059a019550b4f41e21c0be6df7f2.svg";